/**
 * Calcule les cellules sous un pinceau carré centré sur `(centerCol, centerRow)`
 * et de taille `size` (côté en perles).
 *
 * `size = 1` → 1 cellule (le centre). `size = 3` → 3×3 = 9 cellules. `size = 5` → 25.
 * Les cellules hors-bornes du pattern sont filtrées (pas d'erreur).
 *
 * Choix MVP : pinceau **carré**. Plus prévisible pour l'utilisateur final que circulaire,
 * et cohérent avec la grille de cellules carrées. Variante circulaire en V2 si demande.
 */
export function brushCells(
  centerCol: number,
  centerRow: number,
  size: number,
  patternWidth: number,
  patternHeight: number,
): Array<{ col: number; row: number }> {
  if (size <= 0 || !Number.isInteger(size)) {
    throw new Error(`brushCells : size invalide ${size} (attendu entier ≥ 1).`);
  }
  if (size === 1) {
    if (
      centerCol < 0 ||
      centerCol >= patternWidth ||
      centerRow < 0 ||
      centerRow >= patternHeight
    ) {
      return [];
    }
    return [{ col: centerCol, row: centerRow }];
  }
  const radius = Math.floor(size / 2);
  const result: Array<{ col: number; row: number }> = [];
  for (let dr = -radius; dr <= radius; dr++) {
    for (let dc = -radius; dc <= radius; dc++) {
      const c = centerCol + dc;
      const r = centerRow + dr;
      if (c < 0 || c >= patternWidth || r < 0 || r >= patternHeight) continue;
      result.push({ col: c, row: r });
    }
  }
  return result;
}
